import { zetApi } from '@zet/network'

export type IPincodeDetails = {
  data: {
    circleName: string
    regionName: string
    district: string
    officeName: string
    officeType: string
    divisionName: string
    pincode: number
    stdCode: string
    stateName: string
  }
}

const getPincodeDetails = async ({ pincode }: { pincode: string }) => {
  const response = await zetApi.get<IPincodeDetails>(
    `/user/pincode-details?pincode=${pincode}`
  )

  return response?.data || {}
}
export { getPincodeDetails }
